import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';

import { getTenantLicense, type License } from '../../api/licenses';
import { stateLine } from './TenantLicensePanel';

/** The license warning on a tenant admin's Dashboard — expiring within 45
 *  days, ended, read-only, or over a limit; nothing otherwise. Coordinators
 *  can't read the license, so for them it stays empty. */
export function LicenseBanner({ tenantId }: { tenantId: string }) {
  const [license, setLicense] = useState<License | null>(null);

  useEffect(() => {
    let alive = true;
    getTenantLicense(tenantId).then(
      (l) => alive && setLicense(l),
      () => alive && setLicense(null),
    );
    return () => {
      alive = false;
    };
  }, [tenantId]);

  const line = license ? stateLine(license) : null;
  if (!line) return null;
  return (
    <Alert
      severity={line.severity}
      action={
        <Button color="inherit" size="small" component={RouterLink}
          to="/tenant/settings?tab=license">
          License
        </Button>
      }
    >
      {line.text}
    </Alert>
  );
}
